var map = {
	"./font-fa-brands.css": "2f6e",
	"./font-fa-regular.css": "3b8d",
	"./font-fa-solid.css": "8b3c",
	"./font-md-action.css": "678b",
	"./font-md-alert.css": "1084",
	"./font-md-av.css": "aa5a",
	"./font-md-communication.css": "8843",
	"./font-md-content.css": "1749",
	"./font-md-device.css": "d31c",
	"./font-md-editor.css": "c5c7",
	"./font-md-file.css": "0e50",
	"./font-md-hardware.css": "abdb",
	"./font-md-image.css": "f16d",
	"./font-md-maps.css": "bde3",
	"./font-md-navigation.css": "70b9",
	"./font-md-notification.css": "4ba5",
	"./font-md-places.css": "0199",
	"./font-md-social.css": "c803",
	"./font-md-toggle.css": "c70c",
	"./font-ot.css": "0991"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8501";